var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("select-box", {
        ref: "acno",
        attrs: {
          value: _vm.selected,
          "option-list": _vm.list,
          label: _vm.label,
          "label-i18n":
            _vm.pageOption == "myQr" ? "MFXD-01-03-01-03" : "MPAY-02-01-24-03",
          disabled: _vm.disabled,
          readonly: _vm.readonly,
          "default-text": _vm.defaultTextData,
          template: "drwot",
          cssType: "latest",
          required: "required"
        },
        on: {
          "update:value": function($event) {
            _vm.selected = $event
          },
          "update:optionList": function($event) {
            _vm.list = $event
          },
          "update:option-list": function($event) {
            _vm.list = $event
          },
          "update:defaultText": function($event) {
            _vm.defaultTextData = $event
          },
          "update:default-text": function($event) {
            _vm.defaultTextData = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "noData",
            fn: function() {
              return [
                _c("div", { staticClass: "notice normal" }, [
                  _c("div", { staticClass: "notice-tit" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          /*선택 가능한 계좌가 없습니다.*/ _vm.$t(
                            "MCOM-0000083"
                          )
                        )
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "notice-cont" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          /*다음과 같은 이유로 계좌가 표시되지 않습니다.*/ _vm.$t(
                            "MCOM-0000071"
                          )
                        )
                      )
                    ]),
                    _c(
                      "ol",
                      { staticClass: "olist olist-number-type info-guide" },
                      [
                        _c("li", [
                          _c("span", { staticClass: "num" }, [_vm._v("①")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                /*출금 계좌 이외에 내 계좌가 없는 경우*/ _vm.$t(
                                  "MCOM-0000072"
                                )
                              ) +
                              " "
                          )
                        ]),
                        _c("li", [
                          _c("span", { staticClass: "num" }, [_vm._v("②")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                /*거래 가능한 통화를 가진 계좌가 없는 경우*/ _vm.$t(
                                  "MCOM-0000073"
                                )
                              ) +
                              " "
                          )
                        ]),
                        _vm.isCorporationUser
                          ? _c("li", [
                              _c("span", { staticClass: "num" }, [_vm._v("③")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    /*기업 사용자의 경우 이체 권한이 없는 경우*/ _vm.$t(
                                      "MCOM-0000124"
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ])
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "info info-etc-col" },
        [
          _vm.notSelectedWhenButtonClick
            ? _c("div", [
                _c("p", { staticClass: "color-point" }, [
                  _vm._v(_vm._s(_vm.$t("MPAY-05-01-01-07")))
                ])
              ])
            : _vm._e(),
          _vm._t("info"),
          _vm.page != "transfer" &&
          _vm.showOption.includes("dpostBal") &&
          !_vm._.isNil(_vm.dpostBalInfo) &&
          _vm.pageOption !== "myQr"
            ? _c("p", [
                _vm._v(
                  " " +
                    _vm._s(/*출금 가능 금액*/ _vm.$t("MPAY-03-01-06-02")) +
                    " : " +
                    _vm._s(_vm.dpostBalInfo) +
                    " "
                )
              ])
            : _vm._e(),
          _vm._t("error")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }